import { Navigate, useLocation } from "react-router-dom";

export function LegacyFortuneRedirect() {
  const { pathname, search, hash } = useLocation();
  const destination = pathname
    .replace(/^\/games-of-chance(?=\/|$)/, "/fortune")
    .replace(
      /^\/fortune\/melbourne-cup-sweep(?=\/|$)/,
      "/competitions/melbourne-cup-sweep"
    );
  return (
    <Navigate
      to={{
        pathname: destination,
        search,
        hash
      }}
      replace
    />
  );
}
